import { FelaCSS } from '@bridebook/ui';
import { INSTAGRAM_ITEMS_PER_ROW } from '@bridebook/web/app-shared/components/supplier/sections/instagram-widget/instagram-grid-item';

interface IStyles {
  imageWrap: FelaCSS;
  loader: FelaCSS;
  image: FelaCSS;
}

const styles = ({ gap }: { gap: number }): IStyles => ({
  imageWrap: {
    // {gap}px (default 1px) less width for spacing between items
    width: `calc(100% / ${INSTAGRAM_ITEMS_PER_ROW.mobile} - ${gap}px)`,
    aspectRatio: '1 / 1',
    cursor: 'pointer',

    ':hover': {
      opacity: 0.9,
    },

    desktopDesign: {
      // {gap}px (default 1px) less width for spacing between items
      width: `calc(100% / ${INSTAGRAM_ITEMS_PER_ROW.desktop} - ${gap}px)`,
    },
  },

  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    shimmer: true,
  },

  image: {
    zIndex: 1,
    width: '100%',
  },
});

export default styles;
